// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ca9149b","732":"50323a09"}[chunkId] + ".chunk.js";
};